var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSelectGameIcon = function SvgSelectGameIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.887,
    height: 16.689
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "selectGameIcon_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2653"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 174",
    d: "M20.544 11.826c-2.98-5.138-7.469-1.563-7.469-1.563a2.255 2.255 0 01-1.193.422h-1.2a2.745 2.745 0 01-1.377-.22S5 6.689 2.017 11.827A16.551 16.551 0 00.239 22.556c.21 1.37.47 2.008 1.779 1.893s4.112-3.728 4.112-3.728c.234-.294 1.182-.22 1.546-.22h7.208a1.581 1.581 0 011.088.535s2.832 3.574 4.139 3.688 2-.8 2.211-2.169a16.546 16.546 0 00-1.778-10.729zm-4.882-.136z",
    transform: "translate(1.727 -8.547)",
    fill: "url(#selectGameIcon_svg__a)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "fun"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 174",
    d: "M22.171 3.279c-3.127-5.138-7.838-1.563-7.838-1.563a2.442 2.442 0 01-1.252.422h-1.262a2.425 2.425 0 01-1.251-.42S5.857-1.858 2.729 3.28A15.853 15.853 0 00.863 14.009c.221 1.37.948 2.283 2.321 2.169s4.341-3.688 4.341-3.688a1.694 1.694 0 011.142-.537h7.565a1.691 1.691 0 011.141.535s2.972 3.574 4.344 3.688 2.1-.8 2.32-2.169a15.848 15.848 0 00-1.866-10.728z",
    fill: "none",
    stroke: "#000"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 10",
    d: "M7.831 9.667h-.022a1.02 1.02 0 01-.739-.274v-1.47H5.601a1.221 1.221 0 01-.234-.683 1.583 1.583 0 01.2-.9h1.56V4.788a1.732 1.732 0 01.735-.159h.049a2.064 2.064 0 01.8.188L8.7 6.344h1.47a1.459 1.459 0 01.277.727 1.85 1.85 0 01-.242.851H8.649v1.5a1.45 1.45 0 01-.818.245zm9.512-.035A1.232 1.232 0 1118.575 8.4a1.233 1.233 0 01-1.232 1.232zm3.067-1.57a1.232 1.232 0 111.232-1.232 1.233 1.233 0 01-1.232 1.232zm-3.067-1.819a1.232 1.232 0 111.232-1.231 1.233 1.233 0 01-1.232 1.231z",
    fill: "#fff"
  }))));
};
export default SvgSelectGameIcon;